import React, {Component} from 'react';
import {Row, Col,} from "react-bootstrap";
import moment from 'moment'
import SprawdzKonfiguraceSearchbox from "./components/componentsRozklad/SprawdzKonfiguraceSearchbox";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import ObsadaService from "../obsada/ObsadaService";
import SprawdzKonfiguraceWszystkieTrasyTable from "./components/componentsRozklad/SprawdzKonfiguraceWszystkieTrasyTable";
import SprawdzKonfiguraceTable from "./components/componentsRozklad/SprawdzKonfiguraceTable";

export default class SprawdzKonfiguracjeZakladkaRozklad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start:DateAndTimeFormat.formatYYYYMMDD(moment()),
            koniec:DateAndTimeFormat.formatYYYYMMDD(moment()),
            params:{
                dataOd: null,
                dataDo:null,
                idTr:null,
            },
            konfiguracjaStart:null,
            konfiguracjaKoniec:null,
            rekordy:[]
        };
        this.onClickSzukaj=this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
       this.ustawPoczatkoweWartosci(this.props)
    }

    componentWillReceiveProps(nextprops){
        this.ustawPoczatkoweWartosci(nextprops)
    }

    ustawPoczatkoweWartosci(props){
        this.setState({
            start: props.start,
            koniec: props.koniec,
            konfiguracjaStart: props.start,
            konfiguracjaKoniec: props.koniec,
        })

        this.onClickSzukaj(
            {
                dataOd: props.start,
                dataDo:props.koniec,
                idTr:null,
            }
        )
    }

    onClickSzukaj(params){
        this.setState({params:params, start:params.dataOd, koniec:params.dataDo})
        if(Boolean(params.idTr)){
            ObsadaService.sprawdzKonfiguracje(params).then(function (response) {
                this.setState({rekordy:response.data})
            }.bind(this))
        }
        else{
            ObsadaService.sprawdzKonfiguracjeDlaWszystkichTras(params).then(function (response) {
                this.setState({rekordy:response.data})
            }.bind(this))
        }
    }

    render() {

        return (
           <div>
                    <Row>
                        <Col sm={12}>
                            <SprawdzKonfiguraceSearchbox start={this.state.start} koniec={this.state.koniec} trasy={this.props.trasy}
                                                         handleClickSzukaj={this.onClickSzukaj}
                            />
                        </Col>
                        <Col xs={12}>
                            {
                                (Boolean(this.state.konfiguracjaStart)&&Boolean(this.state.konfiguracjaKoniec))?
                                    <div style={{margin:'5px 15px', color:'grey', fontStyle:'italic'}}>
                                        Obecnie zdefiniowany zakres w konfiguracji: od {this.state.konfiguracjaStart} do {this.state.konfiguracjaKoniec}
                                    </div>
                                    :
                                    ''
                            }
                        </Col>
                        <Col sm={12}>
                            {
                                this.state.params.idTr == null?
                                    <div>
                                        <SprawdzKonfiguraceWszystkieTrasyTable data={this.state.rekordy}/>
                                    </div>
                                    :
                                    <div>
                                        <SprawdzKonfiguraceTable data={this.state.rekordy} trasy={this.props.trasy} idTr={this.state.params.idTr}/>
                                    </div>
                            }
                        </Col>
                    </Row>
           </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/SprawdzKonfiguracjeZakladkaRozklad.js